import { EmptyState } from '../components/DesignSystem';

interface PlaceholderPageProps {
  title: string;
}

/** Temporary stand-in until the feature screens land. */
export function PlaceholderPage({ title }: PlaceholderPageProps) {
  return (
    <EmptyState
      caption={`The ${title} screen is being built on top of this foundation.`}
      icon={<span aria-hidden="true">◌</span>}
      title="Coming soon"
    />
  );
}
